
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, MessageSquare, BarChart, Users, Calendar, Shield, Server, Database } from "lucide-react";

const Features = () => {
  return (
    <section id="benefits" className="py-20 px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">Was wir bieten</h2>
          <p className="text-grey text-lg max-w-3xl mx-auto">
            Eine komplette KI-Infrastruktur mit intuitiven Benutzeroberflächen, 
            professionellem Monitoring und höchsten Sicherheitsstandards.
          </p>
        </div>
        
        {/* Feature 1 */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
          <div className="order-2 md:order-1">
            <h3 className="text-primary font-semibold text-xl mb-2">OpenWebUI</h3>
            <h4 className="text-2xl font-bold mb-6 text-dark">Intuitive Chat-Oberfläche</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MessageSquare className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Komplette Chathistorie und Konversationsverwaltung</span>
              </li>
              <li className="flex items-start gap-3">
                <Users className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Admin-Backend mit umfassender Benutzerverwaltung</span>
              </li>
              <li className="flex items-start gap-3">
                <Calendar className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Modellauswahl und -verwaltung nach deinen Bedürfnissen</span>
              </li>
            </ul>
            {/* Hidden but kept in code */}
            <Button variant="link" className="text-primary p-0 mt-6 flex items-center gap-1 hidden">
              <span>Mehr erfahren</span>
              <ArrowRight size={16} />
            </Button>
          </div>
          <div className="order-1 md:order-2 bg-white p-4 rounded-2xl shadow-custom">
            <img 
              src="/assets/images/openwebui-chat.png" 
              alt="OpenWebUI Interface" 
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>
        
        {/* Feature 2 */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
          <div className="bg-white p-4 rounded-2xl shadow-custom">
            <img 
              src="/assets/images/dashboard-analytics.jpg" 
              alt="LiteLLM Monitoring" 
              className="w-full h-auto rounded-xl"
            />
          </div>
          <div>
            <h3 className="text-primary font-semibold text-xl mb-2">LiteLLM</h3>
            <h4 className="text-2xl font-bold mb-6 text-dark">Professionelles Monitoring</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <BarChart className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Detaillierte Anfragenprotokollierung und Nutzungsstatistiken</span>
              </li>
              <li className="flex items-start gap-3">
                <Users className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Umfassende Modellverwaltung und Berechtigungseinstellungen</span>
              </li>
              <li className="flex items-start gap-3">
                <Shield className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Höchste Sicherheitseinstellungen und Zugriffskontrollen</span>
              </li>
            </ul>
            {/* Hidden but kept in code */}
            <Button variant="link" className="text-primary p-0 mt-6 flex items-center gap-1 hidden">
              <span>Mehr erfahren</span>
              <ArrowRight size={16} />
            </Button>
          </div>
        </div>
        
        {/* Feature 3 */}
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1">
            <h3 className="text-primary font-semibold text-xl mb-2">Deutsche Server</h3>
            <h4 className="text-2xl font-bold mb-6 text-dark">Hosting auf Azure oder Stackit Cloud in Deutschland</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Shield className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">DSGVO-konform mit höchsten Datenschutzstandards</span>
              </li>
              <li className="flex items-start gap-3">
                <Server className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Modernste Infrastruktur für optimale Performance</span>
              </li>
              <li className="flex items-start gap-3">
                <Database className="text-primary mt-1 flex-shrink-0" size={20} />
                <span className="text-grey">Vollständige Kontrolle über alle Daten und Prozesse</span>
              </li>
            </ul>
            {/* Hidden but kept in code */}
            <Button variant="link" className="text-primary p-0 mt-6 flex items-center gap-1 hidden">
              <span>Mehr erfahren</span>
              <ArrowRight size={16} />
            </Button>
          </div>
          <div className="order-1 md:order-2 bg-white p-4 rounded-2xl shadow-custom">
            <img 
              src="/assets/images/server-code.jpg" 
              alt="German Azure Server" 
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
